import { render, staticRenderFns } from "./BrStatusCount.vue?vue&type=template&id=bf77e5b0&scoped=true"
import script from "./BrStatusCount.vue?vue&type=script&lang=js"
export * from "./BrStatusCount.vue?vue&type=script&lang=js"
import style0 from "./BrStatusCount.vue?vue&type=style&index=0&id=bf77e5b0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf77e5b0",
  null
  
)

export default component.exports